/**
 * Shared breed matching and wizard entry answers.
 * Used by the new wizard and the landing-page breed block.
 */
(function () {
  var AGES = { puppy: 'puppy', adult: 'adult', senior: 'senior' };
  var SHAPES = { heavy: 'heavy', normal: 'normal', slim: 'slim' };
  var ACTIVITIES = {
    indoorinactive: 'indoorInactive',
    indoor: 'indoorInactive',
    low: 'low',
    moderate: 'moderate'
  };
  var EATING = { easy: 'easy', picky: 'picky', very_picky: 'very_picky', verypicky: 'very_picky' };
  var FOODS = { dry: true, wet: true, frozen: true, raw: true, home: true };
  var ISSUES = {
    dental: true, overweight: true, skin: true, joints: true, stomach: true,
    arthritis: true, heart: true, thyroid: true, pancreatitis: true, struvite: true,
    kidney: true, epilepsy: true, ibd: true, cancer: true, recovery: true,
    diabetes: true, liver: true, cushing: true, malabsorption: true
  };

  function locale() {
    var raw = (window.__wizardBreedEmbed && window.__wizardBreedEmbed.locale)
      || window.__wizard1CurrentLocale
      || window.__wizard2CurrentLocale
      || (document.documentElement && document.documentElement.lang)
      || 'nl';
    return String(raw).toLowerCase().indexOf('nl') === 0 ? 'nl' : 'en';
  }

  function breeds() {
    return window.Wizard1Breeds || [];
  }

  function otherLabel() {
    var node = document.querySelector('[data-translate="quiz.steps.breed.option_other"]');
    if (node) {
      var text = (node.getAttribute('data-translate-value') || node.textContent || '').trim();
      if (text) return text;
    }
    var cfg = window.__wizardBreedEmbed;
    if (cfg && cfg.other) return String(cfg.other);
    return locale() === 'nl' ? 'Anders' : 'Other';
  }

  function knownBreeds() {
    return breeds().filter(function (breed) {
      return breed && breed.value !== 'mixed' && breed.value !== 'dont_know';
    });
  }

  function resolveBreed(raw) {
    var text = String(raw || '').trim();
    if (!text) return '';
    var key = text.toLowerCase();
    if (key === 'other' || key === 'anders') return 'other';
    if (key === 'mixed' || key === 'kruising') return 'mixed';
    if (key === 'dont_know' || key === 'unknown' || key === 'weet ik niet') return 'dont_know';
    var exact = knownBreeds().find(function (breed) {
      return String(breed.value || '').toLowerCase() === key
        || String(breed.label_en || '').toLowerCase() === key
        || String(breed.label_nl || '').toLowerCase() === key;
    });
    return exact ? exact.value : text;
  }

  function displayBreed(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (raw === 'other') return otherLabel();
    var row = breeds().find(function (breed) { return breed.value === raw; });
    if (!row || row.value === 'mixed' || row.value === 'dont_know') return raw;
    return locale() === 'nl'
      ? (row.label_nl || row.label_en || raw)
      : (row.label_en || row.label_nl || raw);
  }

  function matches(query) {
    var text = String(query || '').trim().toLowerCase();
    var list = knownBreeds();
    if (!text) return list.slice();
    return list.filter(function (breed) {
      var en = String(breed.label_en || '').toLowerCase();
      var nl = String(breed.label_nl || '').toLowerCase();
      var value = String(breed.value || '').toLowerCase();
      return en.indexOf(text) !== -1 || nl.indexOf(text) !== -1 || value.indexOf(text) !== -1;
    });
  }

  function withOther(query, list) {
    if (list.length || !String(query || '').trim()) return list;
    var label = otherLabel();
    return [{ value: 'other', label_en: label, label_nl: label }];
  }

  function readEntry(params) {
    var patch = {};
    var breed = params.get('breed');
    if (breed && String(breed).trim()) {
      var resolved = resolveBreed(breed);
      patch.breed = resolved;
      patch.breedUnknown = resolved === 'dont_know';
      patch.breedMixed = resolved === 'mixed';
    }
    var age = String(params.get('age') || '').trim().toLowerCase();
    if (AGES[age]) patch.ageGroup = AGES[age];
    var weight = parseFloat(params.get('weight'));
    if (Number.isFinite(weight) && weight >= 1 && weight <= 100) patch.weight = weight;
    var shape = String(params.get('composition') || params.get('shape') || '').trim().toLowerCase();
    if (SHAPES[shape]) patch.composition = SHAPES[shape];
    var activity = String(params.get('activity') || '').trim().toLowerCase();
    if (ACTIVITIES[activity]) patch.activity = ACTIVITIES[activity];
    var eating = String(params.get('eating') || '').trim().toLowerCase();
    if (EATING[eating]) patch.eating = EATING[eating];
    var food = String(params.get('food') || '').split(',').map(function (part) {
      return part.trim().toLowerCase();
    }).filter(function (part) { return FOODS[part]; });
    if (food.length) patch.currentFood = food;
    var health = String(params.get('health') || '').trim().toLowerCase();
    var issues = String(params.get('issues') || '').split(',').map(function (part) {
      return part.trim().toLowerCase();
    }).filter(function (part) { return ISSUES[part]; });
    if (health === 'none') {
      patch.health = 'none';
    } else if (health === 'some' || issues.length) {
      patch.health = 'some';
      if (issues.length) patch.healthIssues = issues;
    }
    return patch;
  }

  function readDogCount(params) {
    var raw = String(params.get('dogs') || '').trim();
    if (!/^\d+$/.test(raw)) return 0;
    var count = parseInt(raw, 10);
    if (count < 1) return 0;
    return count > 20 ? 20 : count;
  }

  function sorted(list) {
    var labelKey = locale() === 'nl' ? 'label_nl' : 'label_en';
    return list.slice().sort(function (a, b) {
      var left = String(a[labelKey] || a.label_en || a.value || '').toLowerCase();
      var right = String(b[labelKey] || b.label_en || b.value || '').toLowerCase();
      return left.localeCompare(right);
    });
  }

  function paintOptions(dropdown, list, onPick) {
    var labelKey = locale() === 'nl' ? 'label_nl' : 'label_en';
    dropdown.innerHTML = '';
    if (!list.length) {
      dropdown.hidden = true;
      dropdown.style.display = 'none';
      return;
    }
    list.forEach(function (breed) {
      var option = document.createElement('div');
      option.className = 'breed-option';
      option.textContent = breed[labelKey] || breed.label_en || breed.value;
      option.addEventListener('mousedown', function (event) {
        event.preventDefault();
        onPick(breed);
      });
      dropdown.appendChild(option);
    });
    dropdown.hidden = false;
    dropdown.style.display = 'block';
  }

  function mountOne(root, index) {
    if (root.getAttribute('data-wizard-breed-ready') === 'true') return;
    root.setAttribute('data-wizard-breed-ready', 'true');
    root.setAttribute('data-instant-styles', 'none');
    root.classList.add('wizard-breed-embed');
    var cfg = window.__wizardBreedEmbed || {};
    var wizard = String(root.getAttribute('data-wizard') || 'w4').trim().toLowerCase();
    if (wizard !== 'w3' && wizard !== 'w4' && wizard !== 'w5') wizard = 'w4';
    var labelText = root.getAttribute('data-label') || cfg.label || otherLabel();
    var buttonText = root.getAttribute('data-button') || cfg.button || 'Stel je box samen';
    var placeholder = root.getAttribute('data-placeholder') || cfg.placeholder || '';
    var inputId = 'wizard-breed-embed-' + index;

    root.innerHTML = '';
    var label = document.createElement('label');
    label.className = 'wizard-breed-embed__label';
    label.htmlFor = inputId;
    label.textContent = labelText;

    var field = document.createElement('div');
    field.className = 'breed-input-wrapper';
    var input = document.createElement('input');
    input.type = 'text';
    input.id = inputId;
    input.autocomplete = 'off';
    input.placeholder = placeholder;
    var dropdown = document.createElement('div');
    dropdown.className = 'breed-dropdown';
    dropdown.hidden = true;
    var portal = document.createElement('div');
    portal.className = 'wizard-breed-embed wizard-breed-embed--float';
    portal.setAttribute('data-wizard-breed-embed', '');
    portal.setAttribute('data-instant-styles', 'none');
    portal.hidden = true;
    portal.appendChild(dropdown);
    document.body.appendChild(portal);
    field.appendChild(input);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'wizard-primary-button';
    button.textContent = buttonText;

    root.appendChild(label);
    root.appendChild(field);
    root.appendChild(button);

    var picked = '';
    function placePortal() {
      var rect = input.getBoundingClientRect();
      portal.style.top = rect.bottom + 'px';
      portal.style.left = rect.left + 'px';
      portal.style.width = rect.width + 'px';
    }
    function closePortal() {
      portal.hidden = true;
      dropdown.hidden = true;
      dropdown.style.display = 'none';
      field.classList.remove('has-dropdown');
    }
    function show(query) {
      var list = sorted(withOther(query, matches(query)));
      paintOptions(dropdown, list, function (breed) {
        picked = breed.value;
        input.value = breed[locale() === 'nl' ? 'label_nl' : 'label_en'] || breed.label_en || breed.value;
        closePortal();
      });
      if (!list.length) {
        closePortal();
        return;
      }
      field.classList.add('has-dropdown');
      portal.hidden = false;
      placePortal();
    }

    input.addEventListener('input', function () {
      picked = '';
      show(input.value);
    });
    input.addEventListener('focus', function () { show(input.value); });
    window.addEventListener('scroll', function () {
      if (!portal.hidden) placePortal();
    }, true);
    window.addEventListener('resize', function () {
      if (!portal.hidden) placePortal();
    });
    document.addEventListener('click', function (event) {
      if (root.contains(event.target) || portal.contains(event.target)) return;
      closePortal();
    });
    button.addEventListener('click', function () {
      var breed = picked || resolveBreed(input.value);
      var url = new URL(cfg.url || '/wizard', window.location.origin);
      url.searchParams.set('j', wizard);
      if (breed) url.searchParams.set('breed', breed);
      window.location.assign(url.pathname + url.search);
    });
  }

  function mountEmbeds() {
    var nodes = document.querySelectorAll('[data-wizard-breed-embed]');
    if (!nodes.length) return;
    var cfg = window.__wizardBreedEmbed || {};
    if (cfg.css && !document.querySelector('link[data-wizard-breed-embed-css]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cfg.css;
      link.setAttribute('data-wizard-breed-embed-css', '');
      document.head.appendChild(link);
    }
    var start = function () {
      nodes.forEach(function (node, index) { mountOne(node, index); });
    };
    if (window.Wizard1Breeds || !cfg.breeds) {
      start();
      return;
    }
    var script = document.createElement('script');
    script.src = cfg.breeds;
    script.onload = start;
    script.onerror = start;
    document.head.appendChild(script);
  }

  window.WizardBreedEntry = {
    locale: locale,
    otherLabel: otherLabel,
    resolveBreed: resolveBreed,
    displayBreed: displayBreed,
    matches: matches,
    withOther: withOther,
    readEntry: readEntry,
    readDogCount: readDogCount,
    mountEmbeds: mountEmbeds
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountEmbeds);
  } else {
    mountEmbeds();
  }
})();
